module.exports = __webpack_public_path__ + "static/media/screenshot(53).53e28875.jpg";